import axios from "axios";

// 1. URL Base con fallback para evitar errores si el .env falla
const server_url = process.env.REACT_APP_PRODUCCION || 'http://localhost:3000';
console.log("server_url");
console.log(server_url);

const serverApi = axios.create({
    baseURL: `${server_url}/api`,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 2. Interceptor de Petición (Sincrónico para mayor velocidad)
serverApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            // El backend usa x-token en lugar de Bearer
            config.headers['x-token'] = token;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 3. Interceptor de Respuesta (Manejo global de errores)
serverApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {

            console.log(error.response);


            // El servidor respondió con un código de error (4xx, 5xx)
            switch (error.response.status) {
                case 401:
                    console.error('No autorizado - Token inválido o expirado');
                    localStorage.clear();
                    window.location.reload();
                    // Opcional: limpiar token si ya no sirve
                    // localStorage.removeItem('token');
                    break;
                case 403:
                    console.error('Prohibido - No tienes permisos');
                    break;
                case 500:
                    console.error('Error interno del servidor');
                    break;
                default:
                    console.error(`Error ${error.response.status}:`, error.response.data);
            }
        } else if (error.request) {
            // La petición se hizo pero no hubo respuesta (Error de red/CORS)
            console.error('Error de red: No se pudo conectar con el servidor');
        } else {
            console.error('Error al configurar la petición:', error.message);
        }

        return Promise.reject(error);
    }
);

export default serverApi;